import { InstituteSearchResponse } from "../../../Models/Institute";
import { BaseAPICallsHandler } from "../BaseAPICallsHandler";
import { NetworkUtils } from "../NetworkUtils";
import { ServerConfig } from "../ServerConfig";

export class InstituteAPIHandler {
    
    public static shared = new InstituteAPIHandler()
    
    apiHandler = BaseAPICallsHandler.shared
    serverConfig = ServerConfig.shared
    networkUtils = NetworkUtils.shared

    // dependency injection here
    constructor();
    constructor(apiHandler: BaseAPICallsHandler, serverConfig: ServerConfig, networkUtils: NetworkUtils);
    public constructor(...params: any[]) {
        if(params.length >= 3) {
            this.apiHandler = params[0];
            this.serverConfig = params[1];
            this.networkUtils = params[2];
        }
    };

    /**
     * Search for institutes based on query
     * @param query - The search query string
     * @param page - Page number (optional, defaults to 1)
     * @param limit - Number of results per page (optional, defaults to 20)
     * @returns Promise<InstituteSearchResponse> - The search results with pagination info
     */
    public async searchInstitutes(query: string, page: number = 1, limit: number = 20): Promise<InstituteSearchResponse> {
        let queryParams = new URLSearchParams()
        queryParams.append('query', query);
        
        if (page !== 1) {
            queryParams.append('page', page.toString());
        }
        
        if (limit !== 20) {
            queryParams.append('limit', limit.toString());
        }

        let url = this.serverConfig.instituteAPIs.searchInstitutesAPI + `?${queryParams.toString()}`;
        
        try {
            let instituteResponse = await this.apiHandler.makeGetRequest({}, url);
            
            // Extract the data from the API response
            const responseData = instituteResponse.data;
            const searchResponse: InstituteSearchResponse = {
                institutes: responseData.institutes,
                pagination: responseData.pagination
            };

            return Promise.resolve(searchResponse);

        } catch (err) {
            return Promise.reject(err);
        }
    }
}